import React from 'react';
import './SidePanelToggle.css';

const SidePanelToggle = ({ isVisible, onToggle }) => {
  return (
    <button 
      className="side-panel-toggle-fab" 
      onClick={onToggle}
      aria-label={isVisible ? 'Hide side panel' : 'Show side panel'}
    >
      {isVisible ? '✕' : 'i'}
    </button>
  );
};

export default SidePanelToggle; 